import Localization from 'lib/localization';

export default {
    lxNavigationHandBookTitle() {
        return Localization.get('bumble_profile@safety_center.articles.safety_handbook.title');
    },
    lxNavigationHelplinesTitle() {
        return Localization.get('badoo_safety_center@navigation.helplines.title');
    },
    lxNavigationToolsTitle() {
        return Localization.get('badoo_safety_center@navigation.tools.title');
    },
    lxNavigationGuidesTitle() {
        return Localization.get('badoo_safety_center@navigation.guides.title');
    },
    lxNavigationUpdatesTitle() {
        return Localization.get('badoo_safety_center@navigation.updates.title');
    },

    lxNavigationOpenA11yLabel() {
        return Localization.get('badoo_safety_center@navigation.open.a11y.label');
    },
    lxNavigationCloseA11yLabel() {
        return Localization.get('badoo_safety_center@navigation.close.a11y.label');
    },
    lxNavigationA11yLabel() {
        return Localization.get('badoo_safety_center@navigation.main.a11y.label');
    },
    lxNavigationModalA11yLabel() {
        return Localization.get('badoo_safety_center@navigation.modal.a11y.label');
    },
};
